// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app {\n  overflow-x: hidden;\n  width: 100vw;\n  height: 100vh;\n}\n.edit-head {\n  background: #353944;\n}\n", ""]);
// Exports
module.exports = exports;
